import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { RGUFilter } from '../api/DashboardApi';

type ChartFilters = {
  accountRef: string;
  usageType?: UsageTypeValue;
  chartType?: ChartTypeValue;
};

type SunscriptionChartFilters = {
  accountRef: string;
  rguFilter?: RGUFilter;
};

export const dashboardQueries = {
  all: ['Dashboard'],
  subscriptionStatus: (filters: SunscriptionChartFilters) => [
    ...dashboardQueries.all,
    'Subscription Status',
    filters,
  ],
  activeInSession: (filters: ChartFilters) => [
    ...dashboardQueries.all,
    'Active in Session',
    filters,
  ],
  rSimStatus: (filters: ChartFilters) => [...dashboardQueries.all, 'rSimStatus', filters],
  monthlyUsage: (filters: ChartFilters) => [...dashboardQueries.all, 'monthlyUsage', filters],
  dailyUsage: (filters: ChartFilters) => [...dashboardQueries.all, 'dailyUsage', filters],
  inventory: (filters: ChartFilters) => [...dashboardQueries.all, 'inventory', filters],
};
